import React from "react";
import MainContainer from "../../container/MainContainer";
import { Link } from "react-router-dom";
import time from "../../images/attraction-time.svg";
import { hasuraClient } from "../../apolloClient";
import { useQuery } from "@apollo/react-hooks";
import { GET_ATTRACTION_BY_ID } from "../../query/GetAttractionById";
import dummyimage from "../../images/picture.svg";
import moment from "moment";
import Arrow from "../../images/Arrow-Right.svg";
import { GET_TYPE_OF_ATTRACTIONS } from "../../query/getTypeOfAttraction";
import location from "../../images/location-icon.svg";
import DeleteAttraction from "../Popup/DeleteAttraction";

const AttractionDetails = (props) => {
  const [modalShow, setModalShow] = React.useState(false);
  const { id } = props.match.params;

  const { data, refetch } = useQuery(GET_ATTRACTION_BY_ID, {
    variables: { id: id },
    client: hasuraClient,
  });

  const { data: categoriesData } = useQuery(GET_TYPE_OF_ATTRACTIONS, {
    client: hasuraClient,
  });

  React.useEffect(() => {
    refetch();
  }, []);

  var foundCategoryName = categoriesData?.type_of_attractions?.find(function (
    category
  ) {
    return category?.name === data?.attractions_by_pk?.type_of_attraction;
  });

  return (
    <MainContainer active="attractions">
      <div className="attraction-cover attraction-details">
        <div className="attraction-header">
          <div className="main-title">
            <div className="back-button" style={{ display: "flex" }}>
              <Link to="/attractions" style={{ marginRight: "20px" }}>
                <img src={Arrow} alt="arrow right" />
              </Link>
              <h1>
                {" "}
                {data?.attractions_by_pk?.name
                  ? data?.attractions_by_pk?.name
                  : ""}{" "}
              </h1>
            </div>
          </div>
          <div className="attraction-right">
            <div className="delete-attraction-btn">
              <button
                className="secondary-button"
                onClick={() => setModalShow(true)}
              >
                Delete attraction
              </button>
              <DeleteAttraction
                id={id}
                show={modalShow}
                onHide={() => setModalShow(false)}
                isDetails={true}
              />
            </div>

            <div class="post-button">
              <Link
                to={{
                  pathname: `/edit-attraction/${id}`,
                  state: {
                    name: `${
                      data?.attractions_by_pk?.name
                        ? data?.attractions_by_pk?.name
                        : ""
                    }`,
                    description: `${
                      data?.attractions_by_pk?.description
                        ? data?.attractions_by_pk?.description
                        : ""
                    }`,
                    categories: `${
                      data?.attractions_by_pk?.type_of_attraction
                        ? data?.attractions_by_pk?.type_of_attraction
                        : ""
                    }`,
                    image_url: `${
                      data?.attractions_by_pk?.image_url
                        ? data?.attractions_by_pk?.image_url
                        : ""
                    }`,
                    image_path: "",
                    openingHours: data?.attractions_by_pk?.open_hours
                      ? data?.attractions_by_pk?.open_hours
                      : [],
                    same_open_hours: data?.attractions_by_pk?.same_open_hours
                      ? data?.attractions_by_pk?.same_open_hours
                      : false,
                    location_text: data?.attractions_by_pk?.location_text
                      ? data?.attractions_by_pk?.location_text
                      : "",
                    location: data?.attractions_by_pk?.location
                      ? data?.attractions_by_pk?.location
                      : "",
                  },
                }}
                className="button"
              >
                Edit attraction
              </Link>
            </div>
          </div>
        </div>
        <div className="attraction-detail-row">
          <div className="attraction-col-left">
            <div className="attraction-image">
              <img
                src={
                  data?.attractions_by_pk?.image_url
                    ? data?.attractions_by_pk?.image_url
                    : dummyimage
                }
                alt="attraction iamge"
              />
            </div>
            <label>
              {" "}
              {foundCategoryName?.name ? foundCategoryName?.name : ""}{" "}
            </label>
            <h3>Description</h3>
            <p
              style={{
                inlineSize: "500px",
                overflowWrap: "break-word",
              }}
            >
              {data?.attractions_by_pk?.description
                ? data?.attractions_by_pk?.description
                : ""}
            </p>
          </div>
          <div className="attraction-col-right">
            <h2>Details</h2>

            <div className="time-block">
              <div className="icon">
                <img src={time} alt="clock icon" />
              </div>
              <div className="time-content">
                {data && data?.attractions_by_pk?.open_hours
                  ? JSON.parse(data?.attractions_by_pk?.open_hours)?.map(
                      (day) => {
                        return (
                          <p
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                              marginBottom: 10,
                            }}
                          >
                            {" "}
                            <label>{day.dayName} : </label>{" "}
                            {day?.close === null ||
                            day?.close === "" ||
                            day?.open === null ||
                            day?.open === "" ? (
                              "Closed"
                            ) : (
                              <>
                                {day.open
                                  ? moment(day.open, "hh:mm").format("hh:mm A")
                                  : null}{" "}
                                -{" "}
                                {day.close
                                  ? moment(day.close, "hh:mm").format("hh:mm A")
                                  : null}{" "}
                              </>
                            )}
                          </p>
                        );
                      }
                    )
                  : null}
              </div>
            </div>
            <div className="time-block">
              <div className="icon">
                <img src={location} alt="clock icon" />
              </div>
              <div className="location-content" style={{ marginTop: "5px" }}>
                <h6> {data?.attractions_by_pk?.location_text}</h6>
                {/* <p>{data?.events_by_pk?.location?.location_text}</p> */}
              </div>
            </div>
            <div className="attraction-footer">
              <div className="attraction-footer-col">
                {/* <div className="attraction-ft-cover">
                  <div className="icon">
                    <img src={like} alt="like icon" />
                  </div>
                  <p>0 likes</p>
                </div> */}
              </div>
              <div className="attraction-footer-col">
                {/* <div className="attraction-ft-cover">
                  <div className="icon">
                    <img src={shared} alt="like icon" />
                  </div>
                  <p>0 shared</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default AttractionDetails;
